/**
 * List helpers shared by the MTM referential screens: availability summary,
 * header sort transitions and sort keys.
 */
export const displayAvailability = (data: {
  availablePermanent?: unknown;
  availableVillaDior?: unknown;
}): string => {
  if (data.availablePermanent && data.availableVillaDior) return 'P & VD';
  if (data.availablePermanent) return 'P';
  if (data.availableVillaDior) return 'VD';
  return '';
};

export interface ListSort<Field extends string> {
  by: Field;
  reverse: boolean;
}

/** Same field flips the order, a new field sorts ascending. */
export const nextListSort = <Field extends string>(
  current: ListSort<Field>,
  by: Field,
): ListSort<Field> =>
  current.by === by
    ? { by, reverse: !current.reverse }
    : { by, reverse: false };

/** Lower-cased text key of a `data` field (`''` when missing). */
export const textKey = (value: unknown): string =>
  String(value ?? '').toLowerCase();

/** Numeric key of a `data` field, NaN when missing (sorted last, as lodash did). */
export const numberKey = (value: unknown): number =>
  Number(value ?? Number.NaN);
